import { RouteConfig } from "vue-router";

export const RNotificationsBrowse: RouteConfig = {
  path: "",
  name: "NotificationsBrowse",
  component: () =>
    import(
      /* webpackChunkName: "notifications-browse" */
      "./VNotificationsBrowse.vue"
    ),
  meta: {
    title: "Notifications",
    version: 2,
  },
};
